module.exports = __webpack_public_path__ + "img/image25.95d255cc.png";